/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCommandDocumentCloudWatchOutputConfig {
    getFixupPrototypeFunction() { return AwsSsmCommandDocumentCloudWatchOutputConfig.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCommandDocumentCloudWatchOutputConfig>): AwsSsmCommandDocumentCloudWatchOutputConfig {
        let obj = Object.assign(new AwsSsmCommandDocumentCloudWatchOutputConfig(), model);
        AwsSsmCommandDocumentCloudWatchOutputConfig.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCommandDocumentCloudWatchOutputConfig>): AwsSsmCommandDocumentCloudWatchOutputConfig {
        if (!model) return null;
        return AwsSsmCommandDocumentCloudWatchOutputConfig.newInstance(<AwsSsmCommandDocumentCloudWatchOutputConfig> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCommandDocumentCloudWatchOutputConfig) {
        if (!obj) return;

        models.AwsSsmCommandDocumentCloudWatchOutputConfig.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCommandDocumentCloudWatchOutputConfig): boolean {
        Object.setPrototypeOf(obj, AwsSsmCommandDocumentCloudWatchOutputConfig.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The name of the CloudWatch Logs log group where you want to send command output.
     */
    cloud_watch_log_group_name: string;

    /**
     * Enables Systems Manager to send command output to CloudWatch Logs.
     */
    cloud_watch_output_enabled: boolean;

}
